import React from "react";
import "./Blog.css";
import Blog_outer from "./Blog_outer/Blog_outer";

function Blog() {
  return (
    <section className="Blog">
      <div className="custom_container">
        <div className="blog_content_holder">
          <Blog_outer />
        </div>
      </div>
    </section>
  );
}

export default Blog;
